import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a0bf9bd62fc4a0014610235/academy_1779169725006/src/app/not-found.tsx");
